import './common/base';

cr$.ready(function () {
    cr$.byClass('add-vlpre-cart').click(function () {
        const elem = cr$.byEl(this);
        window.dataLayer.push({
            event: 'addToCartProduct',
            'product-size-name': elem.attr('data-size'),
            'product-id': elem.attr('data-id'),
            'product-name': 'Vale presente',
            'product-price': elem.attr('data-price'),

            'product-category': '',
            'product-sub-category': '',
            'product-currency': 'BRL',
            'product-stock': 1,
        });
    });
});
